// Shipping Time Countdown
if (!customElements.get('shipping-time')) {
  customElements.define(
    'shipping-time',
    class ShippingTimeUpdate extends HTMLElement {
      constructor() {
        super();
        this.fetchVariantInfo(
          window.location.search.includes('variant=')
            ? window.location.search.split('variant=')[1]
            : this.dataset.variantId
        );
      }

      fetchVariantInfo(variantId) {
        if (!variantId) return;

        const gid = 'gid://shopify/ProductVariant/' + variantId;
        const query = `
          query getProductVariant($id: ID!){
            node(id: $id) {
              ... on ProductVariant {
                id
                title
                availableForSale
                selectedOptions {
                  name
                  value
                }
                quantityAvailable
                isDeposit: metafield(namespace: "custom", key: "is_deposit") {
                  value
                }
                storeAvailability(first: 5) {
                  nodes {
                    available
                    location {
                      name
                    }
                  }
                }
                product {
                  id
                  title
                  metafield (namespace: "custom", key: "lead_time") {
                    value
                  }
                }
              }
            }
          }
        `;

        fetch('https://velodrom-barcelona.myshopify.com/api/2024-07/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'dadc23c4598a46df4983ad35299b568d',
          },
          body: JSON.stringify({ query, variables: { id: gid } }),
        })
          .then((response) => response.json())
          .then((data) => {
            this.updateShippingText(data.data.node);
          })
          .catch((error) => console.error(error));
      }

      updateShippingText(data) {
        var now = new Date();
        var day = now.getDay();
        var end;
        var diffInHours;
        var diffInMinutes;

        var textValue = this.dataset.shippingTimeTodayArrival;
        var shippingTimeText = document.getElementById('shipping-time-text');
        var shippingTimeCountdown = document.getElementById('shipping-time-countdown');

        // Product is a deposit
        var isDeposit = data.isDeposit && data.isDeposit.value === 'true' ? true : false; // ?This is because the query returns an string
        var hasStock = data.availableForSale;
        var store_availabilities_available = () => {
          var isAvilable = isDeposit
            ? data.quantityAvailable > 0
            : data.storeAvailability.nodes.find((node) => node.available === true);
          return !!isAvilable;
        };

        // Shipping availability - Next two bussiness days
        const getNextAvailableDays = (now) => {
          let day = now.getDay();
          let hour = now.getHours();
          let nextAvailableDays = [];
          let shopLocale = this.dataset.shopLocale;

          const options = { weekday: 'short', day: 'numeric', month: 'short' };
          const formatter = new Intl.DateTimeFormat(shopLocale, options);

          const addDays = (daysToAdd, numberOfDays) => {
            let count = 0;
            while (count < numberOfDays) {
              let nextDay = new Date(now);
              nextDay.setDate(nextDay.getDate() + daysToAdd);

              if (nextDay.getDay() >= 1 && nextDay.getDay() <= 5) {
                nextAvailableDays.push(formatter.format(nextDay));
                count++;
              }
              daysToAdd++;
            }
          };

          let daysToAdd = 1; // Default value

          if (day === 5 && hour >= 15) {
            // Friday after 15:00 -> Tuesday and Wednesday
            daysToAdd = 4;
          } else if (day === 5 || (day === 4 && hour >= 15) || day === 0 || day === 6) {
            // Friday before 15:00, Thursday after 15:00 or weekends
            daysToAdd = 3;
          } else if (day === 4 && hour < 15) {
            // Thursday before 15:00 -> Friday and Monday
            daysToAdd = 1;
          } else if (day >= 1 && day <= 3 && hour >= 15) {
            // Monday to Tuesday after 15:00
            daysToAdd = 2;
          }

          addDays(daysToAdd, 2);

          return nextAvailableDays;
        };

        /*
          Shipping availability  for warehouse 
          - Before 15: add 5 -7 Business days
          - After 15: add 6 - 8 Business days
        */
        const addWarehouseDays = (now, minDays, maxDays) => {
          const addBusinessDays = (date, daysToAdd) => {
            let daysAdded = 0;
            var resultDate = new Date(date);
            while (daysAdded < daysToAdd) {
              resultDate.setDate(resultDate.getDate() + 1);

              if (resultDate.getDay() !== 0 && resultDate.getDay() !== 6) {
                daysAdded++;
              }
            }
            return resultDate;
          };

          const minShippingDate = addBusinessDays(now, minDays);
          const maxShippingDate = addBusinessDays(now, maxDays);

          let shopLocale = this.dataset.shopLocale;
          const formatter = new Intl.DateTimeFormat(shopLocale, {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
          });

          return [
            formatter.format(minShippingDate).replace(',', ''),
            formatter.format(maxShippingDate).replace(',', ''),
          ];
        };

        if (!hasStock) {
          // No stock and product not marked as continue selling
          shippingTimeText.innerHTML = '';
          shippingTimeCountdown.innerHTML = '';

          var shippingTimeText = document.querySelector('.shipping-time');
          shippingTimeText.style.minHeight = '0px';
        } else {
          if ((day == 5 && now.getHours() >= 15) || day == 6 || day == 0) {
            // Friday after 15:00, Saturday and Sunday
            if (!store_availabilities_available()) {
              // No stock
              if (isDeposit) {
                // Product is a deposit
                textValue = this.dataset.shippingPreOrderText;
                var leadTime = data.product.metafield?.value !== '0' ? data.product.metafield.value : '';
                shippingTimeCountdown.innerHTML = leadTime + ' ' + this.dataset.shippingPreOrderTime;
              } else {
                textValue = this.dataset.shippingTimeWarehouseTodayArrival;
                shippingTimeCountdown.innerHTML = addWarehouseDays(now, 5, 7).join(' - ');
              }
            } else {
              // There is stock
              textValue = this.dataset.shippingTimeTodayArrivalWeekend;
              shippingTimeCountdown.innerHTML = getNextAvailableDays(now).join(' - ');
            }
          } else {
            // Monday to Friday before 15:00
            if (!store_availabilities_available()) {
              // No  stock
              if (isDeposit) {
                // Product is a deposit
                textValue = this.dataset.shippingPreOrderText;
                var leadTime = data.product.metafield?.value !== '0' ? data.product.metafield.value : '';
                shippingTimeCountdown.innerHTML = leadTime + ' ' + this.dataset.shippingPreOrderTime;
              } else {
                // Product on warehouse
                let arrivalDates;

                if (now.getHours() < 15) {
                  // Before 15:00
                  arrivalDates = addWarehouseDays(now, 4, 6);
                } else {
                  // After 15:00
                  arrivalDates = addWarehouseDays(now, 4, 6);
                }

                textValue = this.dataset.shippingTimeWarehouseTodayArrival;
                shippingTimeCountdown.innerHTML = `<strong>${arrivalDates.join('  - ')}</strong>`;
              }
            } else {
              // With stock
              if (day >= 1 && day <= 5 && now.getHours() < 15) {
                // Monday to Friday before 15:00
                end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15, 0, 0, 0);
              } else {
                // Monday to Friday after 15:00
                end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 15, 0, 0, 0);
                textValue = this.dataset.shippingTimeTomorrowArrival;
              }

              var timeleft = end.getTime() - now.getTime();
              diffInHours = Math.floor(timeleft / (1000 * 60 * 60));
              diffInMinutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));

              shippingTimeText.innerHTML = textValue.replace(
                'AVAILABLE_DAYS',
                `<strong>${getNextAvailableDays(now).join('  - ')}</strong>`
              );
              shippingTimeCountdown.innerHTML = `${diffInHours}HRS ${diffInMinutes}MIN`;
              return;
            }
          }
          shippingTimeText.innerHTML = textValue;
        }
      }
    }
  );
}
